<div id="order" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
             fxLayout="row" fxLayoutAlign="space-between center">

            <!-- APP TITLE -->
            <div fxLayout="row" fxLayoutAlign="start center">

                <button mat-icon-button class="mr-16" [routerLink]="'/orders'">
                    <mat-icon>arrow_back</mat-icon>
                </button>

                <div fxLayout="column" fxLayoutAlign="start start">
                    <div class="h2">
                        {{ 'Order'|translate }} {{order.uuid}}
                    </div>
                    <div class="subtitle secondary-text">
                        <span *ngIf="order.customer">{{order.customer.firstName}} {{order.customer.lastName}}</span>
                    </div>
                </div>
            </div>
            <!-- / APP TITLE -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <!-- CONTENT -->
            <div class="content">

                <mat-tab-group fxLayout="column" fxFlex>

                    <mat-tab label="{{'Order Details'|translate}}">

                        <div class="order-details tab-content p-24" fusePerfectScrollbar>

                            <div class="section pb-48">

                                <div class="pb-16" fxLayout="row" fxLayoutAlign="start center">
                                    <mat-icon class="m-0 mr-16 secondary-text">account_circle</mat-icon>
                                    <div class="h2 secondary-text">{{ 'Customer'|translate }}</div>
                                </div>

                                <div class="customer mb-32">
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td style="font-weight: bold;">{{'Online order' | translate}}: </td>
                                            <td>
                                                <span *ngIf="order.isOnlineOrder">
                                                    {{'Yes'|translate}}
                                                </span>
                                                <span *ngIf="!order.isOnlineOrder">
                                                    {{'No'|translate}}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="font-weight: bold;">{{'Assigned to card' | translate}}: </td>
                                            <td>
                                                <span *ngIf="order.isAssignedToCard">
                                                    {{'Yes'|translate}}
                                                </span>
                                                <span *ngIf="!order.isAssignedToCard" style="color: red;">
                                                    {{'No'|translate}}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr *ngIf="order.paymentMethod && order.paymentMethod.length>0">
                                            <td style="font-weight: bold;">{{'Payment method' | translate}}: </td>
                                            <td>
                                                {{order.paymentMethod}} - {{order.firstPaymentMethodValue}} zł
                                            </td>
                                        </tr>
                                        <tr *ngIf="order.secondPaymentMethod && order.secondPaymentMethod.length>0">
                                            <td style="font-weight: bold;">{{'Second payment method' | translate}}: </td>
                                            <td>
                                                {{order.secondPaymentMethod}} - {{order.secondPaymentMethodValue}} zł
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div class="customer mb-32">
                                    <table class="simple">
                                        <thead>
                                        <tr>
                                            <th>{{ 'Name'|translate }}</th>
                                            <th>{{ 'Email'|translate }}</th>
                                            <th>{{ 'Phone'|translate }}</th>
                                            <th>{{ 'Company'|translate }}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>
                                                <div fxLayout="row" fxLayoutAlign="start center" *ngIf="order.customer">
                                                    <span class="name text-truncate">{{order.customer.firstName}}
                                                        {{order.customer.lastName}}
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <span class="email text-truncate" *ngIf="order.customer">
                                                    {{order.customer.email}}
                                                </span>
                                            </td>
                                            <td>
                                                <span class="phone text-truncate" *ngIf="order.customer">
                                                    {{order.customer.phone}}
                                                </span>
                                            </td>
                                            <td>
                                                    <span class="company text-truncate" *ngIf="order.customer">
                                                        {{order.customer.companyName}}
                                                    </span>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>

<!--                                <mat-accordion class="addresses">-->

<!--                                    <mat-expansion-panel>-->

<!--                                        <mat-expansion-panel-header>-->
<!--                                            <mat-panel-title>{{ 'Customer Address'|translate }}</mat-panel-title>-->
<!--                                        </mat-expansion-panel-header>-->

<!--                                        <div fxFlex fxLayout="column">-->
<!--                                            <div class="address h4 py-24">{{order.customer.street}}-->
<!--                                            </div>-->
<!--                                        </div>-->

<!--                                    </mat-expansion-panel>-->

<!--                                    <mat-expansion-panel>-->

<!--                                        <mat-expansion-panel-header>-->
<!--                                            <mat-panel-title>{{ 'Invoice Address'|translate }}</mat-panel-title>-->
<!--                                        </mat-expansion-panel-header>-->

<!--                                        <div fxFlex fxLayout="column">-->
<!--                                            <div class="address h4 py-24">{{order.customer.street}}-->
<!--                                            </div>-->
<!--                                        </div>-->

<!--                                    </mat-expansion-panel>-->

<!--                                </mat-accordion>-->

                            </div>

                            <div class="section pb-48">

                            </div>
                        </div>
                    </mat-tab>

                    <mat-tab label="{{'Used discounts'|translate}}" *ngIf="order.discounts && order.discounts.length>0">
                        <div class="products tab-content p-24" fusePerfectScrollbar>
                            <table class="simple">
                                <thead>
                                <tr>
                                    <th>{{'Name'|translate}}</th>
                                    <th class="w-120">{{ 'Value'|translate }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr class="product-row" *ngFor="let discount of order.discounts">
                                    <td>
                                        {{discount.discount.name}}
                                    </td>
                                    <td>
                                        {{discount.discount.value}} <span *ngIf="discount.discount.type==='percent'">%</span> <span *ngIf="discount.discount.type!=='percent'">PLN</span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </mat-tab>

                    <mat-tab label="{{'Products'|translate}}">
                        <div class="products tab-content p-24" fusePerfectScrollbar>
                            <table class="simple">
                                <thead>
                                <tr>
                                    <th>{{'Name'|translate}}</th>
                                    <th class="w-120">{{ 'Price'|translate }}</th>
                                    <th class="w-80">{{ 'Quantity'|translate }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr class="product-row" *ngFor="let product of order.items">
                                    <td>
                                        {{product.name}}
                                    </td>
                                    <td>
                                        {{product.priceGross}}
                                    </td>
                                    <td>
                                        {{product.quantity}}
                                    </td>
                                </tr>
                                <tr class="product-row" *ngFor="let product of order.vouchers">
                                    <td>
                                        {{product.voucherTemplate.name}}
                                    </td>
                                    <td>
                                        {{product.priceGross}}
                                    </td>
                                    <td>
                                        {{product.quantity}}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </mat-tab>

                    <mat-tab label="{{'Invoice'|translate}}">

                        <div class="invoice tab-content p-24" fusePerfectScrollbar>

                            <div id="invoice" class="compact page-layout blank" fxLayout="row" fusePerfectScrollbar>

                                <div class="invoice-container">

                                    <!-- INVOICE -->
                                    <div class="card">

                                        <div class="header">
                                            <div class="invoice-date">{{'Created at'|translate}} {{order.createdAt| date:'dd.MM.yyyy H:mm:ss':'UTC'}}</div>

                                            <div fxLayout="row" fxLayoutAlign="space-between stretch">
                                                <div class="client">
                                                    <div class="invoice-number" fxLayout="row" fxLayoutAlign="start center" *ngIf="receipt">
                                                        <span class="title">{{ 'INVOICE'|translate }}</span>
                                                        <span class="number">{{receipt.InvoiceNumber}}</span>
                                                    </div>

                                                    <div class="info">
                                                        <div class="title">
                                                            {{order.customer.firstName}}
                                                            {{order.customer.lastName}}
                                                        </div>
                                                        <div class="address">
                                                            {{order.customer.street}}
                                                        </div>
                                                        <div class="phone">{{order.customer.phone}}</div>
                                                        <div class="email">{{order.customer.email}}</div>
                                                    </div>
                                                </div>

                                                <div class="issuer accent" fxLayout="row" fxLayoutAlign="start center" *ngIf="receipt">
<!--                                                    <div class="logo">-->
<!--                                                        <img src="assets/images/logos/fuse.svg">-->
<!--                                                    </div>-->

                                                    <div class="info">
                                                        <div class="title">{{'Printed at'|translate}} {{receipt.printedAt| date:'dd.MM.yyyy H:mm:ss':'UTC'}}</div>
                                                        <div class="title">
                                                            {{'Read by printer'|translate}}: <span *ngIf="receipt.read">{{'Yes'|translate}}</span>  <span *ngIf="!receipt.read">{{'No'|translate}}</span>
                                                        </div>
                                                        <div class="title">
                                                            {{'Printed'|translate}}: <span *ngIf="receipt.status">{{'Yes'|translate}}</span>  <span *ngIf="!receipt.status">{{'No'|translate}}</span>
                                                        </div>
                                                        <div class="title" *ngIf="receipt.errorCode">
                                                            {{'Printing error code'|translate}}: {{ receipt.errorCode }}<br/>

                                                            <button
                                                                    mat-button
                                                                    class="mr-8"
                                                                    (click)="openRepeatReceiptDialog()"
                                                                    aria-label="Repeat printing"
                                                            >
                                                                {{'Repeat printing'|translate}}
                                                            </button>
                                                        </div>
<!--                                                        <div class="title">FUSE INC.</div>-->
<!--                                                        <div class="address">2810 Country Club Road Cranford, NJ 07016-->
<!--                                                        </div>-->
<!--                                                        <div class="phone">+66 123 455 87</div>-->
<!--                                                        <div class="email">hello@fuseinc.com</div>-->
<!--                                                        <div class="website">www.fuseinc.com</div>-->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="content">

                                            <table class="simple invoice-table" *ngIf="receipt">
                                                <thead>
                                                <tr>
                                                    <th>{{'PRODUCT'|translate}}</th>
                                                    <th class="text-right">{{'PRICE'|translate}}</th>
                                                    <th class="text-right">{{'QUANTITY'|translate}}</th>
                                                    <th class="text-right">{{'TOTAL'|translate}}</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr *ngFor="let product of receipt.Items">
                                                    <td>
                                                        <div class="title">
                                                            {{product.Name}}
                                                        </div>
                                                    </td>
                                                    <td class="text-right">
                                                        {{product.PriceGross}}
                                                    </td>
                                                    <td class="text-right">
                                                        {{product.Quantity}}
                                                    </td>
                                                    <td class="text-right">
                                                        {{product.PriceGross*product.Quantity}}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>

                                        </div>

                                        <div class="footer">
                                            <div class="note">
<!--                                                Please pay within 15 days. Thank you for your business.-->
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start start">
                                                <div class="logo">
<!--                                                    <img src="assets/images/logos/fuse.svg">-->
                                                </div>
                                                <div class="small-note">
<!--                                                    In condimentum malesuada efficitur. Mauris volutpat placerat auctor.-->
<!--                                                    Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum.-->
<!--                                                    Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo-->
<!--                                                    commodo, a suscipit tellus dapibus. Etiam at felis volutpat est-->
<!--                                                    mollis lacinia. Mauris placerat sem sit amet velit mollis, in-->
<!--                                                    porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et-->
<!--                                                    eget eros.-->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- / INVOICE -->

                                </div>
                            </div>
                        </div>
                    </mat-tab>

                </mat-tab-group>

            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->
</div>










<!--
<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="service-details-sidebar" position="left" lockedOpen="gt-md">
        <order-main-sidebar></order-main-sidebar>
    </fuse-sidebar>

    <div class="center">
        <div class="content-card" style="overflow-y: scroll;">
            <table class="simple invoice-table">
                <tbody>
                <tr>
                    <td>{{'Document date'|translate}}</td>
                    <td>{{ order.documentDate | date:'dd.MM.yyyy hh:mm' }}</td>
                </tr>
                <tr>
                    <td>{{'Worker'|translate}}</td>
                    <td>{{order.worker.firstName}} {{order.worker.lastName}} ({{order.worker.username}})</td>
                </tr>
                <tr>
                    <td>{{'Customer'|translate}}</td>
                    <td>{{order.customer.firstName}} {{order.customer.lastName}}; {{order.customer.phone}}</td>
                </tr>
                </tbody>
            </table>
            <div class="h2 mt-16">{{ 'Positions'|translate }}</div>
            <table class="simple invoice-table">
                <thead>
                <tr>
                    <th>{{'Name'|translate}}</th>
                    <th>{{'Quantity'|translate}}</th>
                    <th>{{'Price'|translate}}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let item of order.items">
                    <td>{{item.product.name}}</td>
                    <td>{{item.quantity}}</td>
                    <td>{{item.priceGross}}</td>
                </tr>
                <tr *ngFor="let item of order.vouchers">
                    <td>{{item.voucherTemplate.name}}</td>
                    <td>{{item.quantity}}</td>
                    <td>{{item.priceGross}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
-->
